<template>
  <div>
    <v-toolbar dense color="white">
      <v-toolbar-title>{{ screenTitle }}</v-toolbar-title>
    </v-toolbar>
    <v-form ref="form">
      <v-container fluid>
        <error-message :error-object="errorObject" />
        <success-message :success-object="successObject" />
        <v-row>
          <v-col cols="5">
            <v-text-field
              :value="parseDisasterName"
              label="災害名称"
              placeholder=" "
              disabled
            >
            </v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field
              :value="emergencyStatusName"
              label="緊急事態区分"
              placeholder=" "
              disabled
            >
            </v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field
              :value="deliveryClsName"
              label="配信区分"
              placeholder=" "
              disabled
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <!-- このラジオボタンのCSSはLalertEvacuation.vueにあります -->
          <v-col cols="1" class="custom-label-left">
            <v-text-field label="発令・解除区分" disabled> </v-text-field>
          </v-col>
          <v-col cols="2" class="custom-radio">
            <v-radio-group v-model="submitItem.declareFlg" row disabled>
              <v-radio label="発令" value="0"></v-radio>
              <v-radio label="解除" value="9"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="3">
            <v-text-field
              :value="parsedDeclareCls"
              label="発令区分"
              placeholder=" "
              readonly
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-text-field
              :value="parsedDeliveryArea"
              label="配信先エリア"
              placeholder=" "
              disabled
              readonly
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-textarea
              :value="submitItem.deliveryTitle"
              label="件名"
              placeholder=" "
              disabled
              readonly
              rows="3"
            >
            </v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-textarea
              :value="submitItem.declareReason"
              label="発令・解除理由"
              placeholder=" "
              disabled
              readonly
              rows="3"
            >
            </v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-textarea
              :value="submitItem.lalertMessage"
              label="避難行動指針"
              :placeholder="' '"
              disabled
              readonly
              rows="10"
            >
            </v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-textarea
              :value="submitItem.expandInfo"
              label="補足情報"
              placeholder=" "
              disabled
              readonly
              rows="3"
            >
            </v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <v-textarea
              :value="submitItem.correctCancelReason"
              label="訂正／取消理由"
              placeholder=" "
              disabled
              readonly
              rows="3"
            >
            </v-textarea>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <v-row>
      <v-col>
        <template>
          <v-btn
            class="mx-2"
            color="primary"
            v-if="hasEditAuth()"
            @click="onClickDuplicate"
          >
            コピーして編集
          </v-btn>
          <v-btn class="mx-2" color="primary" @click="onClickReturn"
            >戻る</v-btn
          >
        </template>
      </v-col>
    </v-row>
    <confirm-dialog ref="confirmSubmit"></confirm-dialog>
    <v-overlay :value="overlay" opacity="0.5" color="white">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import Vue from "vue";
import ConfirmDialog from "@/components/ConfirmDialog";
import { EmergencyClass } from "@/js/value-objects/emergency-class";
import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
import Disaster from "@/plugins/disaster";
import { ScreenId } from "@/js/value-objects/screen-id";
import { ScreenCrud } from "@/js/value-objects/screen-crud";
import messageUtils from "@/mixins/message-utils";
import { arrayCount } from "@/js/utils";
import { LalertEvacuationScreenMode } from "@/js/value-objects/lalert-evacuation-screen-mode.js";

Vue.use(Disaster);

const lalertEvacuationRepository = RepositoryFactory.get("lalertEvacuation");

export default {
  mixins: [messageUtils],
  components: {
    ConfirmDialog,
    ErrorMessage: () => import("@/components/ErrorMessage"),
    SuccessMessage: () => import("@/components/SuccessMessage")
  },
  props: {
    delivery_no: String
  },
  data: () => ({
    overlay: false,
    LalertEvacuationScreenMode: "",
    screenId: "",
    screenTitle: "",
    submitItem: {
      deliveryNo: "", // 配信番号
      deliveryNoSub: "", // 配信番号枝番
      disasterNo: "", // 災害番号
      emergCls: EmergencyClass.NL, // 緊急事態区分
      deliveryCls: "NE", // 配信区分
      deliveryTitle: "", // 件名
      lalertMessage: "", // 本文／避難行動指針
      deliveryStatus: "0", // 配信ステータス
      correctCancelReason: "", // 訂正/取消理由
      deliveryCa: "LI", // 配信種別
      dests: [], // 配信エリアAPI送信用
      deliveryArea: [], // 配信先エリア
      declareFlg: "0", // 発令解除区分
      declareCls: "", // 発令区分
      declareReason: "", // 発令・解除理由
      expandInfo: "" // 補足情報
    },
    lalertevacuation: {}, // Lアラート情報
    disasters: [
      {
        disaster_no: 0,
        disaster_name: ""
      }
    ], //災害情報
    municipalities: [] // 市町村情報
  }),

  computed: {
    // 災害名称（参照用）
    parseDisasterName() {
      const disasterItem = this.disasters.find(
        obj => obj.disaster_no === this.submitItem.disasterNo
      );
      if (disasterItem) {
        return disasterItem.disaster_name;
      } else {
        return "";
      }
    },

    // 緊急事態区分（参照用）
    emergencyStatusName() {
      return EmergencyClass.factory(this.submitItem.emergCls).toName();
    },

    // 配信区分コードを配信区分名に変換する
    deliveryClsName() {
      const DELIVERY_CLS_NAMELIST = [
        {
          value: "NE",
          text: "新規広報"
        },
        {
          value: "FU",
          text: "続報"
        },
        {
          value: "CO",
          text: "訂正報"
        },
        {
          value: "CA",
          text: "取消報"
        }
      ];

      return DELIVERY_CLS_NAMELIST.find(
        e => e.value == this.submitItem.deliveryCls
      )?.text;
    },

    // 発令区分コードを発令区分名に変換する
    parsedDeclareCls() {
      // 発令区分コードリスト
      const DECLARE_CLS_LIST = [
        {
          value: "3",
          text: "高齢者等避難"
        },
        {
          value: "4",
          text: "避難指示"
        },
        {
          value: "6",
          text: "警戒区域情報"
        },
        {
          value: "5",
          text: "緊急安全確保"
        }
      ];
      return DECLARE_CLS_LIST.find(e => e.value == this.submitItem.declareCls)
        ?.text;
    },

    // 配信先コードを配信先名に変換する
    parsedDeliveryArea() {
      const municipArray = [];
      this.municipalities.forEach(obj => {
        this.submitItem.deliveryArea.forEach(municip => {
          if (obj.value === municip) {
            municipArray.push(obj.text);
          }
        });
      });
      return municipArray;
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      this.overlay = true;
      // Set the ID & Screen name
      this.LalertEvacuationScreenMode = LalertEvacuationScreenMode.factory(
        this.$route.name
      );
      this.screenId = this.LalertEvacuationScreenMode.getScreenId();
      this.screenTitle = ScreenId.getScreenTitle(this.screenId);
      this.pageTitle(this.screenTitle);

      // 一覧画面で編集・続報・訂正・取消ボタン押下時、初期化する
      this.delivery_no = this.$route.params.delivery_no; // 配信番号

      // 一覧画面でパラメータで渡された値を配信番号作成
      const PARAMS = {
        delivery_no: this.delivery_no?.split("-")[0],
        delivery_no_sub: this.delivery_no?.split("-")[1]
      };

      // 災害情報
      await this.$store
        .dispatch(
          "disasterInfo/loadDisasterInfo",
          this.LalertEvacuationScreenMode.getScreenId()
        )
        .then(() => {
          this.disasters = this.$store.state.disasterInfo.data.results;
        })
        .catch(e => {
          this.handleError(
            e,
            this.LalertEvacuationScreenMode.getScreenId(),
            "lalert-management"
          );
        });

      // 市町村
      await this.$store
        .dispatch("allArea/loadAllArea")
        .then(() => {
          this.municipalities = this.$store.state.allArea.municipalities;
        })
        .catch(e => {
          this.handleError(e, this.screenId, "lalert-management");
        });

      // 参照画面で再読み込みする場合、配信番号がないため一覧画面に戻る
      if (!PARAMS.delivery_no) {
        this.$router.push("/lalert");
      }

      // Lアラート（お知らせ）情報
      await lalertEvacuationRepository
        .list(this.screenId, PARAMS)
        .then(res => {
          this.lalertevacuation = res.data.results[0];
        })
        .catch(e => {
          this.handleError(e, this.screenId, "lalert-management");
        });

      // 各値設定
      this.submitItem.deliveryNo = PARAMS.delivery_no;
      this.submitItem.deliveryNoSub = PARAMS.delivery_no_sub;
      this.submitItem.disasterNo = this.lalertevacuation.disaster_no;
      this.submitItem.emergCls = this.lalertevacuation.emerg_cls;
      this.submitItem.deliveryCls = this.lalertevacuation.delivery_cls;
      this.submitItem.deliveryTitle = this.lalertevacuation.delivery_title;
      this.submitItem.lalertMessage = this.lalertevacuation.lalert_message;
      this.submitItem.correctCancelReason = this.lalertevacuation.correct_cancel_reason;
      this.submitItem.declareFlg = this.lalertevacuation.declare_flg; // 発令解除区分
      this.submitItem.declareCls = this.lalertevacuation.declare_cls; // 発令区分
      this.submitItem.declareReason = this.lalertevacuation.declare_reason; // 発令・解除理由
      this.submitItem.expandInfo = this.lalertevacuation.expand_info; // 補足情報
      if (arrayCount(this.lalertevacuation.dests) > 0) {
        this.lalertevacuation.dests.forEach(dest => {
          this.submitItem.deliveryArea.push(dest.municip_code);
        });
      }

      // 災害名称のテキストボックス設定
      const disasterItem = this.disasters.find(
        obj => obj.disaster_no === this.submitItem.disasterNo
      );
      if (disasterItem) {
        this.submitItem.emergCls = disasterItem.emerg_cls;
      } else {
        this.submitItem.emergCls = EmergencyClass.NL;
      }
      this.overlay = false;
    },

    // 編集画面の権限があるかチェック
    hasEditAuth() {
      const editScreenId = ScreenId.SF2105;
      const editAuth = this.$screenAuthority.find(
        auth => auth.screen_id === editScreenId
      );
      if (editAuth) {
        const screenCrud = ScreenCrud.factory(editAuth.screen_crud);
        return screenCrud.isOperation();
      } else {
        return false;
      }
    },

    // コピーして編集ボタン押下時処理
    async onClickDuplicate() {
      const MESSAGE =
        "「コピーして編集」を行うと、新規に避難情報を発令します。\n" +
        "※現在発生している災害において、避難情報を発令中の場合は\n" +
        " 一覧画面へ戻り、「続報」を選択して配信してください。\n\n" +
        "新規に発令してもよろしいですか？";
      const result = await this.$refs.confirmSubmit.open(MESSAGE, "OK", {
        color: "primary",
        width: 500
      });
      if (!result) {
        return;
      }

      // 登録編集画面遷移
      const DELIVERY_NO_CONCAT = `${this.submitItem.deliveryNo}-${this.submitItem.deliveryNoSub}`;
      this.$router.push({
        name: `lalert-evacuation-duplicate`,
        params: {
          delivery_no: DELIVERY_NO_CONCAT
        }
      });
    },

    // 戻るボタン押下時処理
    onClickReturn() {
      this.$router.push("/lalert");
    }
  }
};
</script>
